var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisinformation = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.747 34.026a.48.48 0 0 1-.476.552H8.972a.48.48 0 0 1-.474-.407L6.835 23.313H3.297a.48.48 0 0 1-.48-.48v-8.246a.48.48 0 0 1 .48-.48H13.68a.48.48 0 0 1 .48.48v8.246a.48.48 0 0 1-.48.48h-.574zM33.284 18.71a3.95 3.95 0 0 1-2.39 3.63v-7.26a3.95 3.95 0 0 1 2.39 3.63M29.342 6.555v24.31a.48.48 0 0 1-.73.41l-12.874-7.821a.48.48 0 0 1-.23-.41v-8.667c0-.168.087-.323.23-.41l12.875-7.822a.48.48 0 0 1 .73.41"
  })));
};
export default SvgDisinformation;